import { useState } from "react";
import { useTranslation } from "react-i18next";
import GenericAlertModal from "@/components/AlertModal";
import { useAppTheme } from "@/utils/theme";

interface UsePermissionAlertReturn {
  showPermissionAlert: () => void;
  PermissionAlertModal: () => JSX.Element | null;
}

export const usePermissionAlert = (
  translationNamespace: "clients" | "auditLogs" | "common" = "clients"
): UsePermissionAlertReturn => {
  const { t } = useTranslation(translationNamespace);
  const theme = useAppTheme();

  const [isAlertOpen, setIsAlertOpen] = useState(false);

  const showPermissionAlert = () => {
    setIsAlertOpen(true);
  };

  const handleCloseAlert = () => {
    setIsAlertOpen(false);
  };

  const PermissionAlertModal = () => {
    if (!isAlertOpen) return null;

    return (
      <GenericAlertModal
        onClick={handleCloseAlert}
        title="Access Denied"
        description={t("client_profile.insufficient_permissions")}
        submitText={t("client_profile.confirm")}
        theme={theme}
      />
    );
  };

  return {
    showPermissionAlert,
    PermissionAlertModal,
  };
};
